import client from "./client";

const authApi = {
  // Legacy password login (keeping for backward compatibility)
  async login(email, password) {
    const { data } = await client.post("/auth/login", { email, password });
    const token = data.accessToken || data.token;
    if (token) localStorage.setItem("edupulse_token", token);
    if (data.refreshToken) localStorage.setItem("edupulse_refresh", data.refreshToken);
    if (data.user) localStorage.setItem("edupulse_user", JSON.stringify(data.user));
    return data;
  },

  async checkEmail(email) {
    const { data } = await client.post("/auth/check-email", { email });
    return data; // { exists: true/false }
  },

  // OTP-based authentication (accepts profile meta for new users)
  async sendOTP(email, meta = {}) {
    const { data } = await client.post("/auth/request-otp", { email, ...meta });
    return data;
  },

  async verifyOTP(email, otp) {
    const { data } = await client.post("/auth/verify-otp", { email, otp });
    const token = data.accessToken || data.token;
    if (token) localStorage.setItem("edupulse_token", token);
    if (data.refreshToken) localStorage.setItem("edupulse_refresh", data.refreshToken);
    if (data.user) localStorage.setItem("edupulse_user", JSON.stringify(data.user));
    return data;
  },

  async refreshToken() {
    const refreshToken = localStorage.getItem("edupulse_refresh");
    const { data } = await client.post("/auth/refresh-token", { refreshToken });
    const token = data.accessToken || data.token;
    if (token) localStorage.setItem("edupulse_token", token);
    if (data.refreshToken) localStorage.setItem("edupulse_refresh", data.refreshToken);
    return data;
  },

  async me() {
    const { data } = await client.get("/auth/me");
    localStorage.setItem("edupulse_user", JSON.stringify(data));
    return data;
  },

  logout() {
    localStorage.removeItem("edupulse_token");
    localStorage.removeItem("edupulse_refresh");
    localStorage.removeItem("edupulse_user");
  },

  // SSO (Google)
  async ssoLogin(idToken) {
    const { data } = await client.post("/auth/sso", { provider: 'google', idToken });
    return data;
  },

  async updateProfile(updates) {
    const { data } = await client.patch("/auth/profile", updates);
    localStorage.setItem("edupulse_user", JSON.stringify(data));
    return data;
  },
};

export default authApi;
